/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SpendRuleActorUsage,
  SpendRuleActorUsage$inboundSchema,
} from "./spendruleactorusage.js";

export type PreviewSpendRuleResult = {
  /**
   * Matched actors with their current-window spend, ordered by spend descending. Capped at 50 entries.
   */
  actors: Array<SpendRuleActorUsage>;
  /**
   * Total number of organization members the target expression matches.
   */
  matchedCount: number;
  /**
   * Exclusive end of the current window used for spend.
   */
  windowEnd: Date;
  /**
   * Inclusive start of the current window used for spend.
   */
  windowStart: Date;
};

/** @internal */
export const PreviewSpendRuleResult$inboundSchema: z.ZodMiniType<
  PreviewSpendRuleResult,
  unknown
> = z.pipe(
  z.object({
    actors: z.array(SpendRuleActorUsage$inboundSchema),
    matched_count: z.int(),
    window_end: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    window_start: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "matched_count": "matchedCount",
      "window_end": "windowEnd",
      "window_start": "windowStart",
    });
  }),
);

export function previewSpendRuleResultFromJSON(
  jsonString: string,
): SafeParseResult<PreviewSpendRuleResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PreviewSpendRuleResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PreviewSpendRuleResult' from JSON`,
  );
}
